import { IconButton, TableCell, TableRow } from "@mui/material";
import { DeleteTwoTone } from "@mui/icons-material";
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import { useState } from "react";
import { dateUsaToInd, getCurrentDate } from "../frames/common";
import './billing.css';

function NewBillItem({ open, onClose, onSuccess }) {
    const [date, setDate] = useState(getCurrentDate());
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [hsn, setHsn] = useState("");
    const [quantity, setQuantity] = useState(1);
    const [rate, setRate] = useState(0);
    const [price, setPrice] = useState(0);
    const [fuel, setFuel] = useState(0);
    const [taxable, setTaxable] = useState(0);
    const [gst, setGst] = useState(0);
    const [total, setTotal] = useState(0);

    if (!open) return (<></>);

    const handleSelfClose = () => {
        setDate(getCurrentDate());
        setTitle("");
        setDescription("");
        setHsn("");
        setQuantity(1);
        setRate(0);
        setPrice(0);
        setFuel(0);
        setTaxable(0);
        setGst(0);
        setTotal(0);
        onClose();
    }
    const validInput = () => {
        if (date === "") return false;
        else if (title.length < 3) return false;
        else if (hsn.length < 3) return false;
        else if (quantity * rate !== price) return false;
        else return true;
    }
    const handleSelfSave = () => {
        if (!validInput()) {
            alert("The details you entered are incorrect. Please check your details.");
            return;
        }
        const _json = {
            "id": Date.now().toString(36).toUpperCase(),
            "sl_no": null,
            "date": dateUsaToInd(date),
            "title": title,
            "description": description,
            "hsn": hsn,
            "quantity": quantity,
            "weight": 0,
            "destination": "",
            "rate": Number(rate.toFixed(2)),
            "other": 0,
            "price": Number(price.toFixed(2)),
            "fuel": Number(fuel.toFixed(2)),
            "gst": Number(gst.toFixed(2))
        }
        onSuccess(_json);
        handleSelfClose();
    }

    const onQuantityChange = (e) => {
        const qty_ = Number(e.target.value);
        const total_ = Number(qty_ * rate);
        const gst_ = Number((total_ + fuel) * 0.18);
        setQuantity(qty_);
        setPrice(total_);
        setGst(gst_);
        setTaxable(total_ + fuel);
        setTotal(total_ + fuel + gst_);
    }

    const onRateChange = (e) => {
        const rate_ = Number(e.target.value);
        const total_ = Number(quantity * rate_);
        const gst_ = Number((total_ + fuel) * 0.18);
        setRate(rate_);
        setPrice(total_);
        setGst(gst_);
        setTaxable(total_ + fuel);
        setTotal(total_ + fuel + gst_);
    }

    const onPriceChange = (e) => {
        const rate_ = Number(e.target.value / quantity);
        const total_ = Number(quantity * rate_);
        const gst_ = Number((total_ + fuel) * 0.18);
        setRate(rate_);
        setPrice(total_);
        setGst(gst_);
        setTaxable(total_ + fuel);
        setTotal(total_ + fuel + gst_);
    }
    const onFuelChange = (e) => {
        const fuel_ = Number(e.target.value);
        const gst_ = Number((price + fuel_) * 0.18);
        setFuel(fuel_);
        setTaxable(price + fuel_);
        setTotal(price + fuel_ + gst_);
    }
    const onTaxableChange = (e) => {
        return;
    }
    const onGSTChange = (e) => {
        const v = Number(e.target.value);
        setGst(v);
        setTotal(v + taxable)
    }
    const onTotalChange = (e) => {
        return;
    }

    const onFuelSet = () => {
        // const res = prompt("Applicable fuel percentage ?", "35");
        // if (res === null) return;
        // const e = { "target": { "value": (price * 18) / 100 } };
        // onFuelChange(e);
    }
    const onGstSet = () => {
        // const res = prompt("Applicable GST percentage ?", "18");
        // if (res === null) return;
        // const e = { "target": { "value": ((price + fuel) * 18) / 100 } };
        // onGSTChange(e);
    }


    return (
        <TableRow>
            <TableCell>
                <IconButton aria-label="delete" size="small" onClick={handleSelfClose}>
                    <DeleteTwoTone color="error" fontSize="inherit" />
                </IconButton>
                <IconButton aria-label="delete" size="small" onClick={handleSelfSave}>
                    <SaveTwoToneIcon color="success" fontSize="inherit" />
                </IconButton>
            </TableCell>
            <TableCell>
                <input type="date" value={date} onChange={(e) => { setDate(e.target.value); }} placeholder="Date" className="new-entry" />
            </TableCell>
            <TableCell>
                <input type="text" value={title} onChange={(e) => { setTitle(e.target.value); }} placeholder="Title" className="new-entry" /><br />
                <input type="text" value={description} onChange={(e) => { setDescription(e.target.value); }} placeholder="Description" className="new-entry" />
            </TableCell>
            <TableCell>
                <input type="text" value={hsn} onChange={(e) => { setHsn(e.target.value); }} placeholder="HSN Code" className="new-entry" />
            </TableCell>
            <TableCell>
                <input type="number" value={quantity} onChange={onQuantityChange} placeholder="Quantity" step="1" min="1" max="10000" className="new-entry" />
            </TableCell>
            <TableCell>
                <input type="number" value={rate} onChange={onRateChange} placeholder="Rate" step="0.01" min="0" max="100000" className="new-entry" />
            </TableCell>
            <TableCell>
                <input type="number" value={price} onChange={onPriceChange} placeholder="Price" step="0.01" min="0" max="100000" className="new-entry" />
            </TableCell>
            <TableCell>
                <input type="number" value={fuel} onChange={onFuelChange} onFocus={onFuelSet} placeholder="Fuel" step="0.01" min="0" max="100000" className="new-entry" />
            </TableCell>
            <TableCell>
                <input type="number" value={taxable} onChange={onTaxableChange} placeholder="Taxable" step="0.01" min="0" max="100000" className="new-entry" />
            </TableCell>
            <TableCell>
                <input type="number" value={gst} onChange={onGSTChange} onFocus={onGstSet} placeholder="GST" step="0.01" min="0" max="100000" className="new-entry" />
            </TableCell>
            <TableCell>
                <input type="number" value={total} onChange={onTotalChange} placeholder="Total" step="0.01" min="0" max="100000" className="new-entry" />
            </TableCell>
        </TableRow>
    );
}

export default NewBillItem;